import { Component, Input, OnChanges } from '@angular/core';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { FieldTypeNumberComponent } from '../../../shared/components/field-type-number/field-type-number.component';
import { FormsModule } from '@angular/forms';
import { CustomizeFieldsSwitchFormComponent } from "../customize-fields-switch-form/customize-fields-switch-form.component";

@Component({
    selector: 'customize-field-num',
    templateUrl: './customize-field-num.component.html',
    standalone: true,
    imports: [
      FormsModule,
      FieldTypeNumberComponent,
      CustomizeFieldsSwitchFormComponent
    ]
})
export class CustomizeFieldNumComponent implements OnChanges {
  customizeFieldNum: any = {
    decimalsInfo: {
        label: this.translate.instant('customize-field-list.decimals'),
        positive: true
    },
    defaultValueInfo: { label: this.translate.instant('customize.default-value') }
  }
  constructor(
    private translate: AfTranslateFactory) { }
  @Input() field: any = null;
  @Input() isPrivate: any = null;
  @Input() hiddenInLandings: boolean = false;
  @Input() concept: any = null;
  @Input() typeView: string = 'normal';
  @Input() previewMode: boolean = false;

  ngOnChanges(): void {
    let that: any = this.customizeFieldNum;
    that.field = this.field;
    if(this.previewMode || (this.concept?.poll && this.concept?.disabled) || that.field.noEditable){
      that.decimalsInfo.noEditable = true;
      that.defaultValueInfo.noEditable = true;
    }
  }

  itemSelected(e:any, item:any){
      this.customizeFieldNum.field[item] = e.newValue;
  }

}
